import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Container,
  // FormField,
  Header,
  // Input,
  SpaceBetween,
} from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import AwsLoginModal from "../modals/AwsLoginModal";
import { isEmpty, regExpAll } from "./utils.js";
import {
  fetchAwsLoginUrl,
  getEndUserEvent,
} from "../../redux/actions/aws_login";
import { Spinner } from "@cloudscape-design/components";
import { fetchCIDRLookup } from "../../redux/actions/lookups";
// CIDR
import CIDR from "ip-cidr";
// List Leases
import { fetchUserLeases } from "../../redux/actions/leases";

const EventLogin = () => {
  const { urlParamEventId } = useParams();
  const [value, setValue] = useState("xmenevents");
  const [inputError, setInputError] = useState({});
  const [valueChangedOnce, setValueChangedOnce] = useState(false);
  const NotificationItem = useSelector((state) => state.notification);
  const User = useSelector((state) => state.current_user);
  const Config = useSelector((state) => state.config);
  const AwsLogin = useSelector((state) => state.aws_login);
  const dispatch = useDispatch();
  // CIDR
  const [clientIp, setClientIp] = useState("");
  const [cidrList, setCidrList] = useState("");
  const Items = useSelector((state) => state.lookups);
  const navigate = useNavigate();
  const [showSpinner, setShowSpinner] = useState(true);
  const [isAlertShowed, setIsAlertShowed] = useState(false);
  // List Leases
  const LeaseItems = useSelector((state) => state.leases);
  const [spentAmount, setSpentAmount] = useState(0);
  const [expireDate, setExpireDate] = useState("");

  const validateInputs = (newValue, allowEmptyValues = false) => {
    let errors = {};
    if (
      !(allowEmptyValues && newValue === "") &&
      !new RegExp(regExpAll(Config.EVENT_ID_REGEX)).test(newValue)
    ) {
      errors.EVENT_ID =
        "Invalid event ID format. Event ID must consist of " +
        Config.EVENT_ID_LENGTH +
        " alphanumeric characters.";
    }
    setInputError(errors);
    return isEmpty(errors);
  };

  const signOut = () => {
    Auth.signOut().then(() => {
      dispatch({ type: "current_user/clear" });
      navigate("/");
    });
  };

  // IP search in given CIDR Lists
  function isIpInCIDRs(ip, mcidrList) {
    // Split the CIDR list into an array
    const cidrs = mcidrList.split(",");

    // Iterate through each CIDR and check if the IP falls within the range
    for (const cidr of cidrs) {
      const cidrInstance = new CIDR(cidr);
      if (cidrInstance.contains(ip)) {
        // console.log(ip);
        return true; // The IP matches the CIDR range
      }
    }
    // console.log("IP Address Not Found");
    return false; // No matches found
  }

  const submit = () => {
    dispatch({ type: "notification/dismiss" });
    if (!validateInputs(value)) {
      return;
    }
    dispatch(getEndUserEvent(value));
  };

  // const updateFormValue = (update) => {
  //   validateInputs(update, true);
  //   setValue(update);
  // };

  // List Leases
  useEffect(() => {
    dispatch(fetchUserLeases());
    // console.log("Lease Items:", LeaseItems.items);
    // console.log("User.user", User.email);
    let searchString = User.email;
    const matchedObject = LeaseItems.items.find(
      (obj) => obj.user === searchString
    );
    if (matchedObject) {
      setSpentAmount(matchedObject.spendAmount);
      setExpireDate(matchedObject.expiresDate);
    }
  }, [User.isLoggedIn, User.email, LeaseItems.items, dispatch]);

  // CIDR
  useEffect(() => {
    if ((User.isAdmin || User.isOperator) && !isAlertShowed) {
      dispatch(fetchCIDRLookup());
      let vCidrList = Items.item.lookupvalue;
      setCidrList(vCidrList);
      if (cidrList && clientIp) {
        let isAuthIP = isIpInCIDRs(clientIp, cidrList);
        // console.log("isAuthIP: ", isAuthIP);
        if (!isAuthIP) {
          console.log("Client IP: ", clientIp, cidrList);
          signOut();
          setIsAlertShowed(true);
          alert("You are not authorized.");
        } else {
          setShowSpinner(false);
        }
      }
    } else {
      setShowSpinner(false);
    }
  }, [
    dispatch,
    cidrList,
    Items.item.lookupvalue,
    AwsLogin.event.id,
    clientIp,
    User.isAdmin,
    User.isOperator,
  ]);

  useEffect(() => {
    if (User.isAdmin || User.isOperator) {
      dispatch(fetchCIDRLookup());
    }
    // Fetch the client IP from an external API
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setClientIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));
  }, []);

  // useEffect(() => {
  //   // Minimum spinner time of 5 seconds
  //   const timer = setTimeout(() => {
  //     setShowSpinner(false);
  //   }, 5000);
  //   return () => clearTimeout(timer); // Cleanup on unmount
  // }, []);

  //***** */

  useEffect(() => {
    if (
      !valueChangedOnce &&
      isEmpty(AwsLogin.event) &&
      urlParamEventId &&
      User.isLoggedIn
    ) {
      dispatch(getEndUserEvent(urlParamEventId));
    }
  }, [AwsLogin.event, urlParamEventId, dispatch, valueChangedOnce, User]);

  useEffect(() => {
    if (!AwsLogin.event.eventStatus) return;
    switch (AwsLogin.event.eventStatus) {
      case "Waiting":
        dispatch({
          type: "notification/waiting",
          message:
            "This event hasn't been started yet. Please wait until your event operator allows you to log into your AWS account and then refresh this browser page.",
        });
        return;
      case "Running":
        return;
      case "Terminated":
        dispatch({
          type: "notification/terminated",
          message:
            "This event has already been terminated by your event operator.",
        });
        return;
      default:
        dispatch({
          type: "notification/error",
          message:
            "Internal event status error. Please ask your event support for help.",
        });
    }
  }, [AwsLogin.event, dispatch]);

  useEffect(() => {
    dispatch({ type: "aws_login/event_dismiss" });
    dispatch({ type: "notification/dismiss" });
  }, [dispatch]);

  useEffect(() => {
    // Automatically trigger the submit function on component mount
    submit();
  }, []);

  // const isLoading = !AwsLogin.event.id && !cidrList;

  /////////
  // MAIN
  /////////

  return (
    <Container>
      <SpaceBetween size="xl">
        {showSpinner ? (
          <Spinner size="large" />
        ) : (
          <>
            <Header variant="h3">
              {/* Welcome to "{AwsLogin.event.eventName}" */}
              Welcome to Student-Lab
            </Header>
            <h3>
              {expireDate ? (
                <>
                  You have spent: {spentAmount} USD. Your lease will expire on{" "}
                  {expireDate}
                </>
              ) : (
                <>
                  {User.isAdmin || User.isOperator ? null : (
                    <>You do not have any aws lease account assigned.</>
                  )}
                </>
              )}
            </h3>
            <Box>
              {User.isOperator || User.isAdmin ? null : (
                <Alert type="warning" header="IMPORTANT NOTE">
                  In your AWS Console always check if REGION is US-WEST-2. You
                  can change/select Region as show in below picture.
                </Alert>
              )}
            </Box>
            {User.isOperator || User.isAdmin ? null : (
              <>
                <Box>
                  <div>
                    <img src="/home_region_notice.png" alt="Region Notice" />
                  </div>
                </Box>
                <Box>
                  Click the button below to be forwarded to your AWS account. If
                  this is the first time you are using your email address to log
                  into an AWS account for this event, we will assign a new,
                  fresh AWS account to you. If you have already been logging
                  into an AWS account with your email address before, we will
                  log you into the same account again so you can continue your
                  work.
                </Box>
                <Button
                  icon="external"
                  variant="primary"
                  loading={AwsLogin.status === "loading"}
                  onClick={() =>
                    dispatch(fetchAwsLoginUrl({ eventId: AwsLogin.event.id }))
                  }
                  // disabled={NotificationItem.visible}
                  disabled={
                    User.isAdmin || NotificationItem.visible || User.isOperator
                  }
                >
                  Open AWS Console
                </Button>
              </>
            )}
            <AwsLoginModal />
          </>
        )}
        <Alert
          type={NotificationItem.type}
          header={NotificationItem.header}
          onDismiss={() => dispatch({ type: "notification/dismiss" })}
          visible={NotificationItem.visible}
          dismissAriaLabel="Close error"
          dismissible
        >
          {NotificationItem.content}
        </Alert>
      </SpaceBetween>
    </Container>
  );
};

export default EventLogin;
